import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const PhotographerContext = createContext();

export const PhotographerProvider = ({ children }) => {
  const [photographers, setPhotographers] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: LIMIT_DATA_PER_PAGE,
    limit: 100,
    include: "reservations",
    orderBy: "name",
    sort: "asc",
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchPhotographers = useCallback(async () => {
    setPhotographers((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/photographer${queryString}`);
      if (response.success) {
        setPhotographers({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });
      }
    } catch (error) {
      setPhotographers((prevState) => ({
        ...prevState,
        error: "Failed to fetch photographers",
        loading: false,
      }));
    }
  }, [queryString]);

  useEffect(() => {
    fetchPhotographers();
  }, [fetchPhotographers]);

  return (
    <PhotographerContext.Provider
      value={{ photographers, handleSearch, filterOptions, refetch: fetchPhotographers }}
    >
      {children}
    </PhotographerContext.Provider>
  );
};

export const usePhotographer = () => {
  const context = useContext(PhotographerContext);
  if (!context) {
    throw new Error("usePhotographerContext must be used within PhotographerProvider");
  }
  return context;
};
